var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 30C35.5228 24.4772 35.5228 15.5228 30 10C24.4772 4.47715 15.5228 4.47715 10 10C4.47715 15.5228 4.47715 24.4772 10 30C15.5228 35.5228 24.4772 35.5228 30 30Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.468 27.8245H14.5333C13.2333 27.8245 12.1758 26.767 12.1758 25.467V14.5323C12.1758 13.2323 13.2333 12.1748 14.5333 12.1748H25.468C26.768 12.1748 27.8255 13.2323 27.8255 14.5323V25.467C27.8255 26.767 26.768 27.8245 25.468 27.8245ZM14.5333 12.9871C13.6806 12.9871 12.9881 13.681 12.9881 14.5323V25.467C12.9881 26.3197 13.682 27.0122 14.5333 27.0122H25.468C26.3207 27.0122 27.0132 26.3183 27.0132 25.467V14.5323C27.0132 13.6796 26.3193 12.9871 25.468 12.9871H14.5333Z",
    fill: "#020802"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0575 24.5213C17.5969 24.5213 15.5947 22.5191 15.5947 20.0585C15.5947 17.5979 17.5969 15.5957 20.0575 15.5957C22.5181 15.5957 24.5203 17.5979 24.5203 20.0585C24.5203 22.5191 22.5181 24.5213 20.0575 24.5213ZM20.0575 16.4066C18.0442 16.4066 16.4056 18.0451 16.4056 20.0585C16.4056 22.0718 18.0442 23.7104 20.0575 23.7104C22.0708 23.7104 23.7094 22.0718 23.7094 20.0585C23.7094 18.0451 22.0708 16.4066 20.0575 16.4066Z",
    fill: "#020802"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.f47f5137ec1973d78ae8bbef6a94cc4e.svg";
export { ForwardRef as ReactComponent };